import { render, staticRenderFns } from "./term-suggestion.vue?vue&type=template&id=4aae37b9&"
import script from "./term-suggestion.vue?vue&type=script&lang=ts&"
export * from "./term-suggestion.vue?vue&type=script&lang=ts&"
import style0 from "./suggestion.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports